export default __webpack_public_path__ + "static/bg-hero-66ba589cb604e128065ec3d0fd5ec1a8.png";